import {
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { TenantDataService } from '@services/data/tenant-data.service';

export const tenantInterceptor: HttpInterceptorFn = (
    req: HttpRequest<any>,
    next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
    const tenantDataService = inject(TenantDataService);
    const tenantId = tenantDataService.currentTenantId?.toString() ?? '';

    const reqClone = req.clone({
        setHeaders: { 'WF-Tenant-Id': tenantId },
    });

    return next(reqClone);
};
